// localStorage stringifies whatever it is handed, so an absent tenant attribute
// is read back as the truthy string 'undefined'
const ABSENT_VALUES = ['', 'undefined', 'null']

export function resolveTenantId(tenantId?: string | null) {
  const trimmed = tenantId?.trim()
  return trimmed && !ABSENT_VALUES.includes(trimmed) ? trimmed : null
}
